import { useMemo } from "react";
import {
  ArtOrderTextColorByStatus,
  ArtOrderMessageByStatus,
  ArtOrderStatus,
} from "../constants";
import { endyIconByOrderStatus } from "../helpers";

export default function useArtOrderStatus(
  artOrderStatus: ArtOrderStatus,
  iconClassName?: string,
) {
  const EndyIcon = useMemo(
    () => endyIconByOrderStatus(artOrderStatus, iconClassName),
    [artOrderStatus, iconClassName],
  );

  const textColor = useMemo(
    () => ArtOrderTextColorByStatus[artOrderStatus],
    [artOrderStatus],
  );

  const message = useMemo(
    () => ArtOrderMessageByStatus[artOrderStatus],
    [artOrderStatus],
  );

  return { EndyIcon, textColor, message };
}
